module.exports = __webpack_public_path__ + "static/media/Vskit.a347fba9.pdf";